module.exports = __webpack_public_path__ + "static/media/wallfinishes_lcs_10y_n.f6cf010f.csv";